<div *ngIf="cargando" class="flex justify-center items-center min-h-screen">
    <div class="flex flex-col items-center">
      <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 border-t-transparent border-azul rounded-full" role="status">
      </div>
      <p class="mt-4 text-lg text-azul">{{'cargando-producto' | translate}}</p>
    </div>
</div>
<div *ngIf="producto.stock > 0 && !cargando" class="grid grid-cols-1 md:grid-cols-2 gap-4 p-5">
    <div class="col-span-1 animate-fade-right">
        <div class="overflow-hidden inline-block rounded-lg w-full">
            <img class="rounded cursor-zoom-in hover:scale-150 duration-500 transition-transform w-full" src="{{producto.imagen}}" alt="{{producto.nombre}}">
        </div>
    </div>

    <div class="col-span-1 flex flex-col gap-4 rounded-lg p-5 shadow-lg shadow-gray-500 animate-fade-left">
        <!-- Nombre -->
        <div>
            <h1 class="text-xl sm:text-2xl md:text-3xl text-azul">{{producto.nombre}}</h1>
        </div>
        <!-- Precio -->
        <div>
            <span class="text-2xl">{{producto.precio}} €</span>
        </div>
        <!-- Descripcion -->
        <div class="rounded-lg bg-azul bg-opacity-85 p-4 sm:p-5 shadow-lg shadow-blue-900">
            <h2 class="text-white text-xl border-b-2 pb-2">{{"descripcion-producto"| translate}}</h2>
            <p class="ml-3 mt-3 text-white text-left lg:text-left">- {{producto.descripcion}}.</p>
        </div>
        <!-- Contenedor Alertas -->
        <div>
            <!-- Error Talla no seleccionada -->
            <div *ngIf="mostrarErrorTalla" class="mb-3">
                <nz-alert nzType="error" nzCloseable (nzOnClose)="cerrarAlerta()" nzMessage="{{'selecciona-talla' | translate}}" nzShowIcon></nz-alert>
            </div>
            <!-- Producto en cesta -->
            <div *ngIf="mostrarProductoEnCesta" class="mb-3">
                <nz-alert nzType="success" nzCloseable (nzOnClose)="cerrarAlerta()" nzMessage="{{'producto-cesta' | translate}}" nzShowIcon></nz-alert>
            </div>
        </div>
        <!-- Contenedor Tallas -->
        <div *ngIf="esRopa">
            <p class="text-azul text-lg">{{'tallas' | translate}}</p>
            <div class="flex flex-row flex-nowrap gap-2 overflow-x-auto">
                <button class="text-center py-1 px-3 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:text-white" [ngClass]="{'bg-azul text-white': tallaSeleccionada === 'S'}" (click)="seleccionarTalla('S')">S</button>  
                <button class="text-center py-1 px-3 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:text-white" [ngClass]="{'bg-azul text-white': tallaSeleccionada === 'M'}" (click)="seleccionarTalla('M')">M</button>
                <button class="text-center py-1 px-3 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:text-white" [ngClass]="{'bg-azul text-white': tallaSeleccionada === 'L'}" (click)="seleccionarTalla('L')">L</button>
                <button class="text-center py-1 px-3 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:text-white" [ngClass]="{'bg-azul text-white': tallaSeleccionada === 'XL'}" (click)="seleccionarTalla('XL')">XL</button>
                <button class="text-center py-1 px-3 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:text-white" [ngClass]="{'bg-azul text-white': tallaSeleccionada === 'XXL'}" (click)="seleccionarTalla('XXL')">XXL</button>
            </div>
        </div>
        <!-- Selector Cantidad -->
        <div>
            <form class="mt-3 w-full lg:w-1/2">
                <p class="text-azul text-lg">{{'cantidad' | translate}}</p>
                <input name="cantidad" [(ngModel)]="cantidad" type="number" id="number-input" class="border border-blue-700 text-azul rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Introduce cantidad" min="1" max="{{producto.stock}}"/>
            </form>
        </div>
        <!-- Botones -->
        <div class="grid grid-cols-2 gap-3 max-w-md">
            <!-- Compra -->
            <button class="bg-azul text-center py-1 px-5 w-full text-lg leading-8 text-white border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-white hover:shadow-sm hover:shadow-gray-100 hover:border-azul hover:text-azul" (click)="pagarProducto(producto)">{{'comprar-ahora' | translate}}</button>
            <!-- Añadir Carrito -->
            <button class="bg-white text-center py-1 px-5 w-full text-lg leading-8 text-azul border-2 border-azul flex items-center rounded-full justify-center transition-all duration-300 hover:bg-azul hover:shadow-sm hover:shadow-gray-100 hover:border-gray-300 hover:text-white" (click)="agregarProducto(producto)">{{'agregar-carrito' | translate}}</button>
        </div>
    </div>

</div>
